// extracted by mini-css-extract-plugin
export default {"withPadding":"_50dfcff8","bold":"_17323aee","badgeContainer":"_c39ffbc9"};